import { Link } from "react-router-dom";
import { ShieldCheck, FileClock } from "lucide-react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { ACUERDO_PAGE } from "@/constants/testIds";
import { Footer } from "@/components/Footer";
import { DPA_CONTENT, DPA_PUBLISHED } from "@/content/legalContent";

export default function DataProcessingAgreement() {
  return (
    <div className="min-h-screen bg-background">
      <header className="flex items-center justify-between px-6 md:px-12 py-6">
        <Link to="/" className="flex items-center gap-2">
          <ShieldCheck className="w-7 h-7 text-petroleum" strokeWidth={1.5} />
          <span className="font-heading text-xl font-bold text-charcoal tracking-tight">CERH</span>
        </Link>
      </header>
      <section className="px-6 md:px-12 pb-20 max-w-3xl mx-auto">
        {DPA_PUBLISHED ? (
          <div data-testid={ACUERDO_PAGE.content} className="prose prose-slate max-w-none">
            <h1 className="font-heading text-3xl font-bold text-charcoal mb-1">Acuerdo de Tratamiento de Datos</h1>
            <p className="text-sm text-charcoal/60 mb-6">Última actualización: 30 de agosto de 2026</p>
            <ReactMarkdown
              remarkPlugins={[remarkGfm]}
              components={{
                h2: ({ children }) => <h2 className="font-heading text-xl font-semibold text-charcoal mt-8 mb-3">{children}</h2>,
                p: ({ children }) => <p className="text-sm text-charcoal/75 leading-relaxed mb-3">{children}</p>,
                ul: ({ children }) => <ul className="list-disc pl-5 text-sm text-charcoal/75 space-y-1.5 mb-3">{children}</ul>,
                li: ({ children }) => <li>{children}</li>,
                strong: ({ children }) => <strong className="font-semibold text-charcoal">{children}</strong>,
                hr: () => <hr className="my-8 border-petroleum/10" />,
              }}
            >
              {DPA_CONTENT}
            </ReactMarkdown>
          </div>
        ) : (
          <div data-testid={ACUERDO_PAGE.unpublishedNotice} className="bg-card border border-petroleum/10 rounded-2xl p-8 text-center mt-6">
            <FileClock className="w-8 h-8 text-petroleum/60 mx-auto mb-3" strokeWidth={1.5} />
            <h1 className="font-heading text-2xl font-bold text-charcoal mb-2">Acuerdo de Tratamiento de Datos: en preparación</h1>
            <p className="text-sm text-charcoal/60 max-w-md mx-auto">Estará disponible aquí en breve.</p>
          </div>
        )}
      </section>
      <Footer />
    </div>
  );
}
